export function toPersianDigits(input) {
  if (input === null || input === undefined) return '';
  const s = String(input);
  const map = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
  return s.replace(/[0-9]/g, d => map[Number(d)]);
}

export function loadAdminFloors() {
  try {
    const raw = localStorage.getItem('admin_floors');
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function saveAdminFloors(floors) {
  try {
    localStorage.setItem('admin_floors', JSON.stringify(floors));
  } catch {}
}

